
import Axios from 'axios'
import { Commit } from 'vuex'
import { API } from '@/lib/api'
import Cookies from 'js-cookie'

const AUTHKEY = 'drchronoAuth'
const TOKENKEY = 'drchronoToken'

const state = () => ({
	auth: Cookies.get(AUTHKEY),
	token: Cookies.get(TOKENKEY),
})

const actions = {

	async login({ commit }, params) {
		console.log('loginProvider.params', params)
		try {
			return commit('setAuth', params)
		} catch (error) {
			console.error(error)
		}
	},


	async auth({ commit }, code) {
		let res
		try {
			res = await API.get(
				`/providers/auth`,
				{
					code
				},
				{},
				true,
				{
					'X-Referrer': [window.location.origin, window.location.pathname].join(''),
				}
			)

			console.log({ res, })
		} catch (error) {
			console.error('error', error)
		}

		return res
	},
	async getPatients({ commit, state }, params) {
		const { firstName, lastName, email, gender, } = params

		const res = await API.get(
			`/providers/patients`,
			{
				firstName,
				lastName,
				email,
				gender,
			},
			{},
			true,
			{
				token: state.token,
				'X-Referrer': [window.location.origin, window.location.pathname].join(''),
			},
		)

		return res.results
	},

	async getDoctors({ commit, state }, params) {
		// const { firstName, lastName, email } = params

		const res = await API.get(
			`/providers/doctors`,
			{
			},
			{},
			true,
			{
				token: state.token,
				'X-Referrer': [window.location.origin, window.location.pathname].join(''),
			},
		)

		return res.results
	},

	async addPatient({ commit, state }, data) {
		const { checkin } = data
		if (!checkin) {
			throw new Error(`Missing required data.`)
		}

		const res = await API.send(
			`/providers/patient`,
			data,
			{},
			true,
			{
				token: state.token,
				'X-Referrer': [window.location.origin, window.location.pathname].join(''),
			},
		)

		return res
	},

	async updatePatient({ commit, state }, data) {
		const { checkin, patient } = data
		if (!checkin || !patient) {
			throw new Error(`Missing required data. Please make sure an existing patient is selected.`)
		}
		// console.log( { checkin, patient })

		const res = await API.update(
			`/providers/patient`,
			data,
			true,
			{
				token: state.token,
				'X-Referrer': [window.location.origin, window.location.pathname].join(''),
			},
		)

		return res
	},

	async checkin({ commit, state }, checkin) {
		const api = API.getInstance()
		const { firstName, lastName, email } = checkin

		const res = await api.get(
			`/providers/patients`, {
				firstName,
				lastName,
				email,
			},
			true,
			{
				token: state.token,
				'X-Referrer': [window.location.origin, window.location.pathname].join(''),
			},
		)

		return res.results
	},
}

const mutations = {
	setAuth(state, authData) {
		let expires = 2
		try {
			expires = Number(authData.expires_in) / 60 / 60 / 24
		} catch (error) {

		}

		Cookies.set(AUTHKEY, JSON.stringify(authData), { secure: true, expires, })
		Cookies.set(TOKENKEY, authData.access_token, { secure: true, expires, })

		state.token = authData.access_token
	}
}

const getters = {
	auth: (state) => {
		let auth = {}
		try {
			auth = JSON.parse(Cookies.get(AUTHKEY) )
		} catch (error) {
			console.error(error)
		}

		return auth
	},
	token: (state) => state.token,
}

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
}
